var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('main',[_c('router-view')],1),_c('footer',{staticClass:"footer"},[(_vm.$route.name !== 'home')?_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Back to search ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }